export default "__VITE_ASSET__CRoYj2_y__"